import React, { useState, useEffect } from 'react';
import RouterPropsWrapper from '../../../../common/RouterPropsWrapper';
import DataTable from '../../../../common/components/data-table/DataTable';
import LoadingAnimation from "../../../../common/components/base/LoadingAnimation";
import SimpleSearch from "../../../../common/components/data-table/SimpleSearch";
import AddItemButton from "../../../../common/components/base/AddItemButton";
import ChallengePanel from '../../ChallengePanel';
import { useChallengeInstance } from '../../../../hooks/useChallengeInstance';
import { useChallenge } from '../../../../hooks/useChallenge';
import { useEvaluateStep } from '../../../../hooks/useEvaluateStep';
import SandboxLayout from "../../../../hoc/SandboxLayout/SandboxLayout";
import { campaignAdsManagerData } from "../../../../utils/data/sandboxes";

const columns = ["name", "advertiser", "duration", "actions"];

const CampaignAdServerStep1 = (props) => {
  const { match, history } = props;
  const challengeId = match.params.id;
  
  const [stepTime, setStepTime] = useState(0);
  
  // Fetch challenge instance data
  const { data: challengeInstanceData, isLoading: isLoadingInstance, error: errorInstance } = useChallengeInstance(challengeId);
  
  const challengeType = challengeInstanceData?.challengeInstance?.challengeType;
  
  // Fetch challenge data
  const { data: challengeData, isLoading: isLoadingChallenge, error: errorChallenge } = useChallenge(challengeType);
  
  const evaluateStepMutation = useEvaluateStep();

  // Start step timer
  useEffect(() => {
    const timer = setInterval(() => {
      setStepTime(prevTime => prevTime + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleAdd = async () => {
    const action = {
      actionNeeded: 'click',
      target: 'button',
      parameter: 'new-campaign',
      stepTime: stepTime
    };
    try {
      const res = await evaluateStepMutation.mutateAsync({
        challengeId: challengeId,
        action: action,
        challengeToDo: null
      });
      let value = res.challengeStepEvaluator?.targetLocation || '';
      if (value !== '')
        history.push(value + challengeId);
    } catch (error) {
      console.error('Error evaluating step:', error);
    }
  };

  const handlePreviousPage = (e) => {
    // Not implemented
  };

  const handleNextPage = (e) => {
    // Not implemented
  };

  const handleDeleteRow = (e) => {
    // Not implemented
  };

  const handleKeyPress = (e) => {
    // Not implemented
  };

  if (isLoadingInstance || isLoadingChallenge) return <LoadingAnimation />;
  if (errorInstance) return <div>Error loading challenge instance: {errorInstance.message}</div>;
  if (errorChallenge) return <div>Error loading challenge: {errorChallenge.message}</div>;
  if (!challengeType) return <LoadingAnimation />;
  const challenge = challengeData?.challengeDefinition ? (typeof challengeData.challengeDefinition === 'string' ? JSON.parse(challengeData.challengeDefinition) : challengeData.challengeDefinition) : null;
  if (!challenge) return <LoadingAnimation />;


  const StepCountDownTime = challenge.steps[0].countdownTime;
  if (!('campaigns' in challenge)) {
    challenge['campaigns'] = [];
    challenge.campaigns['records'] = [];
  }

  return (
    <SandboxLayout name="Campaigns" challengeMode={true} layoutData={campaignAdsManagerData}>
      <div className="wizard-container">
        <AddItemButton OnClick={handleAdd} />
        <div className="row">
          <div className="col-sm-12 col-md-10" />
          <div className="col-sm-12 col-md-2">
            <SimpleSearch keyPress={handleKeyPress} />
          </div>
        </div>
        <div>
          <DataTable header='Campaigns'
            editUrl="/campaign/update/"
            columns={columns}
            records={challenge.campaigns}
            deleteRow={handleDeleteRow}
            keyColumn='_id'
            first={e => e.preventDefault()}
          />
          <ChallengePanel
            step={0}
            time={StepCountDownTime}
            description={challenge.challengeDescription}
            coach={challenge.coach}
            challengeTitle={challenge.challengeTitle}
            challengeIsValidation={challenge.isValidation}
            challengeDifficulty={challenge.challengeDifficulty}
            challengeAverageTime={challenge.averageTime}
          />
        </div>
      </div>
    </SandboxLayout>
  );
};

export default RouterPropsWrapper(CampaignAdServerStep1);
